import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { NotificationInterface } from '../../pages/v2/notifications/interfaces/notification.interface';
import { PaginationItems } from '@modules/table-pagination/interfaces/pagination-items.interface';
import { TripUnosResponseInterface } from '../../pages/v2/notifications/interfaces/trip-unos-response.interface';
import { NotificationsFilterInterface } from '../../pages/v2/notifications/interfaces/notifications-filter.interface';
import { IReadNotification } from '../../model/nofitiction.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private readonly url = `${environment.apiHost}/NotificationDashboard`;

  constructor(private readonly httpClient: HttpClient) {}

  getAllNotifications(
    filter: NotificationsFilterInterface,
    onlyLast24Hours = false,
    page = 0,
    limit = 15,
  ): Observable<PaginationItems<NotificationInterface>> {
    const url = `${this.url}/GetNotificationsForUser`;
    const body = {
      ...filter,
      onlyLast24Hours,
      page,
      limit,
    };

    return this.httpClient
      .post<PaginationItems<NotificationInterface>>(url, body)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getUnreadNotificationsCount(): Observable<number> {
    const url = `${this.url}/GetUnreadNotificationsCountForUser`;

    return this.httpClient.get<number>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getTripUnosForUser(): Observable<TripUnosResponseInterface> {
    const url = `${this.url}/GetTripUnosForUser`;

    return this.httpClient.get<TripUnosResponseInterface>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  markAllNotificationsAsRead(): Observable<void> {
    const url = `${this.url}/MarkAllAsRead`;

    return this.httpClient.get<void>(url).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  markNotificationAsRead(requestDetails: IReadNotification): Observable<boolean> {
    const url = `${this.url}/MarkNotificationAsRead`;

    return this.httpClient.post<boolean>(url, requestDetails).pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
